import * as actions from "@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType"
import { RoomData, RoomDetailsListResponse } from "@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType"

export type ProcessTypes = {
  status: boolean
  action: "ROOM_DETAILS_LIST_REQUEST" | "ROOM_DETAILS_GET_REQUEST" | "ROOM_DETAILS_UPDATE_REQUEST" | "ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST" | null
  message?: string | null
}

export type RoomDetailsConfigState = {
  process: ProcessTypes
  dataSource: RoomDetailsListResponse | null
  roomData: RoomData | null
  loading: boolean
}

const initialState: RoomDetailsConfigState = {
  process: {
    status: false,
    action: null,
    message: null,
  },
  loading: false,
  dataSource: null,
  roomData: null,
}

const roomDetailConfigReducer = (
  state: RoomDetailsConfigState = initialState,
  action: actions.RoomDetailsConfigAction,
): RoomDetailsConfigState => {
  switch (action.type) {
    case actions.ROOM_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
      }
    case actions.ROOM_DETAILS_GET_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
        roomData: null,
      }
    case actions.ROOM_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "ROOM_DETAILS_LIST_REQUEST",
          message: "Content loaded successfully",
        },
        dataSource: action.payload,
      }
    case actions.ROOM_DETAILS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "ROOM_DETAILS_GET_REQUEST",
          message: "Room data loaded successfully",
        },
        roomData: action.payload,
      }
    case actions.ROOM_DETAILS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "ROOM_DETAILS_LIST_REQUEST",
          message: action.payload,
        },
        dataSource: null,
      }
    case actions.ROOM_DETAILS_GET_FAILED:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "ROOM_DETAILS_GET_REQUEST",
          message: action.payload,
        },
        roomData: null,
      }
    case actions.ROOM_DETAILS_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
      }
    case actions.ROOM_DETAILS_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "ROOM_DETAILS_UPDATE_REQUEST",
          message: "Room data updated successfully",
        },
      }
    case actions.ROOM_DETAILS_UPDATE_FAILED:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "ROOM_DETAILS_UPDATE_REQUEST",
          message: action.payload,
        },
      }
    case actions.ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
      }
    case actions.ROOM_DETAILS_UPDATE_SORT_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST",
          message: "Sort order updated successfully",
        },
      }
    case actions.ROOM_DETAILS_UPDATE_SORT_ORDER_FAILED:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "ROOM_DETAILS_UPDATE_SORT_ORDER_REQUEST",
          message: action.payload,
        },
      }
    case actions.ROOM_DETAILS_PROCESS_CLEAR:
      return {
        ...state,
        loading: false,
        process: initialState.process,
      }
    default:
      return state
  }
}

export default roomDetailConfigReducer
